import { mutatorAction } from 'satcheljs';
import type { IFeedbackInitOptions } from '../schema/FeedbackTypes';
import { getStore } from '../store/feedbackDialogStore';

export const showFeedbackDialogMutator: (
    targetWindow: Window,
    feedbackInitOptions: IFeedbackInitOptions
) => void = mutatorAction(
    'SHOW_FEEDBACK_DIALOG',
    (targetWindow: Window, feedbackInitOptions: IFeedbackInitOptions): void => {
        const store = getStore();
        store.isOpen = true;
        store.targetWindow = targetWindow;
        store.feedbackInitOptions = feedbackInitOptions;
        store.isLoading = true;
        store.mergedOptions = undefined;
    }
);

export const closeFeedbackDialogMutator: () => void = mutatorAction(
    'CLOSE_FEEDBACK_DIALOG',
    (): void => {
        const store = getStore();
        store.isOpen = false;
        store.targetWindow = undefined;
        store.feedbackInitOptions = undefined;
        store.mergedOptions = undefined;
        store.isLoading = false;
    }
);

export const setMergedFeedbackOptionsMutator: (mergedOptions: IFeedbackInitOptions) => void =
    mutatorAction('SET_MERGED_FEEDBACK_OPTIONS', (mergedOptions: IFeedbackInitOptions): void => {
        const store = getStore();
        store.mergedOptions = mergedOptions;
        store.isLoading = false;
    });

// Public API - wrapper functions for cleaner call sites
export function showFeedbackDialog(
    targetWindow: Window,
    feedbackInitOptions: IFeedbackInitOptions
): void {
    showFeedbackDialogMutator(targetWindow, feedbackInitOptions);
}

export function closeFeedbackDialog(): void {
    closeFeedbackDialogMutator();
}

export function setMergedFeedbackOptions(mergedOptions: IFeedbackInitOptions): void {
    setMergedFeedbackOptionsMutator(mergedOptions);
}
